import React from 'react';
import styled from 'styled-components';
import { experiences } from '../../data/constants';
import ExperienceCard from '../Cards/ExperienceCard';
import SectionHeading from '../common/SectionHeading';

const Section = styled.section`
  width: 100%;
  padding: 120px 24px;
  position: relative;
`;

const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 48px;
`;

const HighlightsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
`;

const HighlightCard = styled.div`
  border-radius: 20px;
  padding: 20px;
  background: rgba(20, 22, 35, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.05);
  color: ${({ theme }) => theme.text_primary};
`;

const HighlightValue = styled.p`
  font-size: 30px;
  margin: 0 0 4px;
  color: ${({ theme }) => theme.primary};
  font-weight: 700;
`;

const HighlightLabel = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.text_secondary};
`;

const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 24px;
`;

const Experience = () => {
  const highlights = [
    { value: '3+', label: 'Years in AI / ML' },
    { value: '6', label: 'Industries served' },
    { value: '20+', label: 'Projects delivered' },
  ];

  return (
    <Section id="experience">
      <Wrapper>
        <SectionHeading
          eyebrow="Experience"
          title="Delivering AI-led outcomes across consulting and product teams"
          description="From early-stage experimentation to enterprise rollouts, I partner with multidisciplinary teams to plan, prototype, and launch intelligent features."
        />
        <HighlightsGrid>
          {highlights.map((item) => (
            <HighlightCard key={item.label}>
              <HighlightValue>{item.value}</HighlightValue>
              <HighlightLabel>{item.label}</HighlightLabel>
            </HighlightCard>
          ))}
        </HighlightsGrid>
        <CardsGrid>
          {experiences.map((experience) => (
            <ExperienceCard key={experience.id || experience.company} experience={experience} />
          ))}
        </CardsGrid>
      </Wrapper>
    </Section>
  );
};

export default Experience;
